'use strict';

module.exports = function (marty, React) {
  marty.createAppMixin = require('./createAppMixin')(React);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/app-mixin/index.js
 ** module id = 541
 ** module chunks = 0
 **/